import { render, staticRenderFns } from "./modules.vue?vue&type=template&id=245ab165&scoped=true"
import script from "./modules.vue?vue&type=script&lang=ts"
export * from "./modules.vue?vue&type=script&lang=ts"
import style0 from "./modules.vue?vue&type=style&index=0&id=245ab165&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ab165",
  null
  
)

export default component.exports